import DeleteButton from './DeleteButton'
export default DeleteButton
